import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Divider, Drawer, Toolbar } from '@mui/material';
import { Profile, SidebarNav } from './components';
import {
  ROLES_MANAGEMENT_ALL,
  ROLES_MANAGEMENT_BASIC,
  ROLE_ADMIN,
  ROLE_MENU_CUSTOMERS,
  ROLE_MENU_EXPENSES,
  ROLE_MENU_PRODUCTS,
  ROLE_MENU_SERVICES,
} from 'commons/constants';
import { isAppTypeCourtRental } from 'commons/helpers/appTypeSettings';

const ROLES_ADMIN = [ROLE_ADMIN];

const drawerWidth = 240;
const drawerWidthShrunk = 62;
const useStyles = makeStyles()((theme) => ({
  drawer: {
    width: drawerWidth,
    // [theme.breakpoints.up('lg')]: {
    //   marginTop: 64,
    //   height: 'calc(100% - 64px)',
    // },
  },
  drawerClosed: {
    width: drawerWidthShrunk,
    // [theme.breakpoints.up('lg')]: {
    //   marginTop: 64,
    //   height: 'calc(100% - 64px)',
    // },
  },
  drawerPaper: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClosed: {
    overflowX: 'auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: drawerWidthShrunk,
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  divider: {
    marginTop: '10px !important',
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
  buttonSair: {
    color: 'tomato',
    width: '100%',
  },
  buttonSairItem: {
    display: 'none',
    [theme.breakpoints.up('xs')]: {
      display: 'block',
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  profileSeparatorContainer: {
    '@media (max-height:710px)': {
      display: 'none',
    },
  },
  // verticalSpacer: {
  //   height: '64px',
  // },
}));

const PAGES = [
  {
    title: 'Agenda',
    href: '/agenda',
    icon: 'book-open',
  },
  {
    title: 'Cobranças',
    href: '/cobrancas',
    icon: 'file-invoice-dollar',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
  },
  {
    title: 'Comandas',
    href: '/comandas',
    icon: 'file-invoice',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
    dividerAfter: true,
  },
  {
    title: 'Msgs Pre-definidas',
    href: '/msgs-pre-definidas',
    icon: 'message',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
  },
  {
    title: 'Clientes & Anamneses',
    href: '/clientes',
    icon: 'users',
    requiredRoles: [...ROLES_MANAGEMENT_BASIC, ROLE_MENU_CUSTOMERS],
  },
  {
    title: 'Serviços & Pacotes',
    href: '/servicos',
    icon: 'briefcase',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_SERVICES],
  },
  {
    title: 'Produtos & Estoque',
    href: '/produtos-estoque',
    icon: 'cart-shopping',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_PRODUCTS],
  },
  {
    title: 'Despesas',
    href: '/despesas',
    icon: 'hand-holding-dollar',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_EXPENSES],
  },
  {
    title: 'Profissionais & Comissão',
    href: '/profissionais',
    icon: 'users',
    requiredRoles: ROLES_ADMIN,
    dividerAfter: true,
  },
  {
    title: 'Performance',
    href: '/performance',
    icon: 'gauge-high',
    requiredRoles: ROLES_ADMIN,
    sectionTitle: 'Relatórios',
  },
  {
    title: 'Resumo Financeiro',
    href: '/relatorios',
    icon: 'chart-column',
    requiredRoles: ROLES_ADMIN,
  },
  {
    title: 'Melhores Clientes',
    href: '/melhores-clientes',
    icon: 'user-tie',
    requiredRoles: ROLES_ADMIN,
    dividerAfter: true,
  },
  {
    title: 'Configurações',
    href: '/configuracoes',
    icon: 'gear',
  },
];

const PAGES_COURT = [
  {
    title: 'Agenda',
    href: '/agenda',
    icon: 'book-open',
  },
  {
    title: 'Cobranças',
    href: '/cobrancas',
    icon: 'file-invoice-dollar',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
    dividerAfter: true,
  },
  {
    title: 'Quadras',
    href: '/quadras',
    icon: 'court-sport',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
  },
  {
    title: 'Msgs Pre-definidas',
    href: '/msgs-pre-definidas',
    icon: 'message',
    requiredRoles: ROLES_MANAGEMENT_BASIC,
  },
  {
    title: 'Clientes',
    href: '/clientes',
    icon: 'users',
    requiredRoles: [...ROLES_MANAGEMENT_BASIC, ROLE_MENU_CUSTOMERS],
  },
  {
    title: 'Serviços',
    href: '/servicos',
    icon: 'briefcase',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_SERVICES],
  },
  {
    title: 'Produtos & Estoque',
    href: '/produtos-estoque',
    icon: 'cart-shopping',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_PRODUCTS],
  },
  {
    title: 'Despesas',
    href: '/despesas',
    icon: 'hand-holding-dollar',
    requiredRoles: [...ROLES_MANAGEMENT_ALL, ROLE_MENU_EXPENSES],
  },
  {
    title: 'Profissionais',
    href: '/profissionais',
    icon: 'users',
    requiredRoles: ROLES_ADMIN,
    dividerAfter: true,
  },
  {
    title: 'Performance',
    href: '/performance',
    icon: 'gauge-high',
    requiredRoles: ROLES_ADMIN,
    sectionTitle: 'Relatórios',
  },
  {
    title: 'Resumo Financeiro',
    href: '/relatorios',
    icon: 'chart-column',
    requiredRoles: ROLES_ADMIN,
  },
  {
    title: 'Melhores Clientes',
    href: '/melhores-clientes',
    icon: 'user-tie',
    requiredRoles: ROLES_ADMIN,
    dividerAfter: true,
  },
  {
    title: 'Configurações',
    href: '/configuracoes',
    icon: 'gear',
  },
];

// COMPONENT
const Sidebar = (props) => {
  const { onSidebarClose, open, variant, className, ...rest } = props;
  const { classes, cx } = useStyles();
  const isCourtRental = isAppTypeCourtRental();

  return (
    <Drawer
      anchor="left"
      className={open ? classes.drawer : classes.drawerClosed}
      classes={{
        paper: cx(classes.drawerPaper, !open && classes.drawerPaperClosed),
      }}
      // onClose={onClose}
      open={open}
      variant="permanent"
    >
      <div {...rest} className={cx(classes.root, className)}>
        {/* <div className={classes.verticalSpacer} /> */}
        <Toolbar />
        <div className={classes.profileSeparatorContainer}>
          <Profile open={open} />
          <Divider className={classes.divider} />
        </div>
        <SidebarNav className={classes.nav} pages={isCourtRental ? PAGES_COURT : PAGES} open={open} />
        {/* <UpgradePlan /> */}
        {/* <ListItem className={classes.buttonSairItem} disableGutters>
          <Button className={classes.buttonSair} onClick={handleLogout}>
            Sair
          </Button>
        </ListItem> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default Sidebar;
